module.exports = __webpack_public_path__ + "img/image_29.a8ef1726.png";